import { useRef } from "react";

import type { FormStore } from "../../store/types";
import type { FieldId, FieldValueType, SelfServiceTaskForm } from "../../types";
import { createInitialValues } from "../../utils/field-utils";
import {
  type FormInitialValueProvider,
  createInitialValueProvider,
} from "../../utils/initial-value-provider";

interface Params {
  store: FormStore;
  formDefinition?: SelfServiceTaskForm;
  initialValues?: Record<FieldId, FieldValueType>;
}

export function useFormInitialize({
  store,
  formDefinition,
  initialValues,
}: Params) {
  // 初期化トラッキング用のref
  const initRef = useRef({
    formInitialized: false,
    initialValueProvider: undefined as FormInitialValueProvider | undefined,
  });

  // レンダリング中に初期化処理を実行
  if (
    formDefinition &&
    !store.initialized &&
    !initRef.current.formInitialized
  ) {
    const provider = createInitialValueProvider(formDefinition, initialValues);
    initRef.current.initialValueProvider = provider;
    store.register(formDefinition);
    store.setInitialValueProvider(provider);

    const values = createInitialValues(formDefinition, provider);
    store.setValues(values, false);

    if (initialValues && Object.keys(initialValues).length > 0) {
      store.setInitialValues(initialValues);
    }
    initRef.current.formInitialized = true;
  }

  return {
    initialized: store.initialized,
  };
}
